/**
 * Created by boris on 3/31/17.
 */
import {
  SET_FOLLOWINGS_LIST,
  INITIAL_FOLLOWINGS_LIST,
  SET_NEXT_FOLLOWINGS_LIST,
  SET_FOLLOWINGS_LIST_USER,
  REMOVE_FOLLOWINGS_LIST_USER,
  SET_SEARCH_FOLLOWINGS_LOADING,
} from '../actions/constants'

const initialState = {
  isLoading:  true,
  users:      new Map(),
  pagination: {},
}

export default function(state = initialState, action) {
  switch (action.type) {
    case INITIAL_FOLLOWINGS_LIST: {
      return {
        isLoading:  true,
        users:      new Map(),
        pagination: {},
      }
    }

    case SET_SEARCH_FOLLOWINGS_LOADING: {
      return {
        isLoading:  true,
        users:      new Map(),
        pagination: {},
      }
    }

    case SET_FOLLOWINGS_LIST: {
      let newState = {
        isLoading:  false,
        users:      new Map(),
        pagination: {},
      }
      if (action.data) {
        const { data, pagination } = action.data
        data.forEach(user => newState.users.set(user.id, user))
        newState.pagination = Object.assign({}, pagination)
      }

      return newState
    }

    case SET_NEXT_FOLLOWINGS_LIST: {
      let newState = Object.assign({}, state, {
        users:      new Map(state.users),
        pagination: Object.assign({}, state.pagination),
      })
      if (action.data) {
        const { data, pagination } = action.data
        data.forEach(user => newState.users.set(user.id, user))
        newState.pagination = Object.assign({}, pagination)
      }

      return newState
    }

    case SET_FOLLOWINGS_LIST_USER: {
      let newState = Object.assign({}, state, {
        users:      new Map(state.users),
        pagination: Object.assign({}, state.pagination),
      })
      if (action.user) {
        const { user } = action
        newState.users.set(user.id, user)
      }

      return newState
    }

    case REMOVE_FOLLOWINGS_LIST_USER: {
      let newState = Object.assign({}, state, {
        users:      new Map(state.users),
        pagination: Object.assign({}, state.pagination),
      })
      if (action.user_id) {
        const { user_id } = action
        newState.users.delete(user_id)
      }

      return newState
    }

    default:
      return state
  }
}
